<!--
/*******************************************************************************
*@ 컴포넌트명   : PersonalInfoTab2.vue
*@ 컴포넌트설명 : 고객정보조회/변경 - 수정 [개인] : 자택주소
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div class="form">
    <!-- 우편번호 -->
    <div class="form-row">
      <input-text
        ref="owhusNmad"
        id="owhusNmad"
        :value.sync="data.owhusNmad"
        label-i18n="MPRS-01-01-04-06"
        placeholder="MPRS-01-01-04-06"
        :maxlength="10"
        :err-msg-param="{filed:$t('MPRS-01-01-04-06'), max:10}"
        toLowerCase
      />
    </div>
    <!-- 상세 주소 : 인도, 오클랜드 제외 -->
    <div class="form-row">
      <div class="item-tit">
        {{ /*상세 주소*/ $t("MPRS-01-01-04-07") }}
        <required />
      </div>
      <div class="item-desc">
        <div class="form-text-field">
          <div class="input-text-field address">
            <input-text
              ref="owhusAddr1"
              id="owhusAddr1"
              :value.sync="data.owhusAddr1"
              placeholder="MPRS-01-01-04-07"
              :maxlength="66"
              :err-msg-param="{filed:$t('MPRS-01-01-04-07'), max:66}"
              :required="`${$config.SITECODE_OGCBD}|${$config.SITECODE_OGHCM}|${$config.SITECODE_OGMMR}`"
              toLowerCase
            />
          </div>
          <div class="input-text-field">
            <input-text
              ref="owhusAddr2"
              id="owhusAddr2"
              :value.sync="data.owhusAddr2"
              :maxlength="66"
              :err-msg-param="{filed:$t('MPRS-01-01-04-07'), max:66}"
              toLowerCase
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 도시, 국가 -->
    <div class="form-row">
      <input-text
        ref="owhusAddr3"
        id="owhusAddr3"
        :value.sync="data.owhusAddr3"
        label-i18n="MPRS-01-01-04-08"
        placeholder="MPRS-01-01-04-08"
        toLowerCase
      />
    </div>
  </div>
</template>
<script>
import Required from "@/components/template/Required";
import { mapFields } from "vuex-map-fields";

export default {
  props: ["data"],
  components: {
    Required,
  },
  computed: {
    ...mapFields(["siteCode"]),
  },
  methods: {
    touch() {
      this.$refs.owhusNmad.$v.$touch();
      this.$refs.owhusAddr1.$v.$touch();
      this.$refs.owhusAddr2.$v.$touch();
      this.$refs.owhusAddr3.$v.$touch();
    },
  },
};
</script>